import { z } from "zod";

export const MealOptionSchema = z.object({
  type: z.enum(["UNPAID", "PAID"]).default("UNPAID"),
  paid_by: z.enum(["CLIENT", "TENANT"]).optional(),
  duration: z.number().default(30), // duration in minutes, defaults to 30 minutes
  after: z.number().default(0), // hours worked before meal break
});
